import {Component, computed, effect, inject, input, OnInit, viewChild} from '@angular/core';
import {DatePipe} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';
import {PageGridComponent} from '../../../shared/components/page-grid/page-grid.component';
import {GridEventOutput, GridModel} from '../../../shared/model/page-grid';
import {KtServicesFilterService} from '../../service/kt-services-filter.service';
import {KtServicesGridService} from '../../service/kt-services-grid.service';
import {IKtServiceListItem} from '../../interfaces/kt-trip.interface';
import {KtServiceDetailModalComponent} from '../kt-service-detail-modal/kt-service-detail-modal.component';

@Component({
  selector: 'app-kt-services-list',
  templateUrl: './kt-services-list.component.html',
  standalone: false,
})
export class KtServicesListComponent implements OnInit {
  private readonly filterService = inject(KtServicesFilterService);
  private readonly gridService = inject(KtServicesGridService);
  private readonly datePipe = inject(DatePipe);
  private readonly dialog = inject(MatDialog);

  readonly salesOrderId = input<number | null>(null);

  protected readonly gridRef = viewChild.required(PageGridComponent);

  protected readonly gridConfig = computed<GridModel<IKtServiceListItem>>(() => ({
    gridDataTestId: 'kt-services-list',
    gridTitle: 'Services',
    defaultPageSize: 25,
    columns: [
      {
        columnProperty: 'id',
        columnHeader: 'Service ID',
        sort: true,
        clickable: true,
        linkEventFunction: (item: IKtServiceListItem) => `/KtService/${item.id}`,
      },
      ...(!this.salesOrderId() ? [{
        columnProperty: 'tripReference',
        columnHeader: 'Trip Reference',
        sort: true,
        textLeft: true,
      }] : []),
      {
        columnProperty: 'productTypeName',
        columnHeader: 'Product Type',
        sort: true,
      },
      {
        columnProperty: 'serviceName',
        columnHeader: 'Service Name',
        sort: true,
        textLeft: true,
        extraWidth: true,
      },
      {
        columnProperty: 'vendorName',
        columnHeader: 'Vendor',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'subVendorName',
        columnHeader: 'Sub-Vendor',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'quotedCost',
        columnHeader: 'Quoted Cost',
        sort: false,
      },
      {
        columnProperty: 'actualCost',
        columnHeader: 'Actual Cost',
        sort: false,
      },
      {
        columnProperty: 'currencyCode',
        columnHeader: 'Currency',
        sort: false,
      },
      {
        columnProperty: 'serviceStartDate',
        columnHeader: 'Start Date',
        sort: true,
        processData: (item) => item ? (this.datePipe.transform(item, 'M/dd/yyyy') ?? '') : '',
      },
    ],
    gridGetService: this.gridService,
  }));

  public ngOnInit(): void {
    if (this.salesOrderId()) {
      this.gridService.salesOrderId = this.salesOrderId();
    }
  }

  constructor() {
    effect(() => {
      const filters = this.filterService.filtersValue();
      if (!filters.ReloadGrid) return;
      this.gridRef().getItems();
    });
  }

  protected handleColumnClick(event: GridEventOutput<IKtServiceListItem>): void {
    if (event.column === 'id') {
      this.dialog.open(KtServiceDetailModalComponent, {
        width: '65%',
        data: {id: event.item.id},
      });
    }
  }
}
